import { APIGet, StatusCode } from "api/protocols";
import { IProduct } from "pages/guest/models/product";

const apiVersion = "2024-04";
const adminType = "guest";
const baseProductUrl = "/" + apiVersion + "/" + adminType + "/product";

interface IGetProducts {
  id?: number;
  sales_channel_type?: string;
  facility_id?: number;
  handle?: string;
  inventory?: boolean;
  modifier_groups?: boolean;
}

interface IGetProductsRes {
  data: IProduct[];
  message: string;
  status: StatusCode;
}

export interface IModifierGroup {
  id?: number;
  title?: string;
  variants?: IVariantModifier[];
  multi_select?: boolean;
  required?: boolean;
}

export interface IVariantModifier {
  id?: number;
  title?: string;
  default?: boolean;
  position?: number;
  price?: number;
  quantity?: number;
}

export async function GetProducts(params: IGetProducts, useGlobalLoader: boolean): Promise<IGetProductsRes> {
  return await APIGet(baseProductUrl, params, useGlobalLoader);
}
